export default __webpack_public_path__ + "static/media/confirmation_number-24px - white.63e1d215.svg";